
<template>
    <veui-dialog
        theme="ai"
        :open="open"
        :overlay-class="`custom-dialog message-rich-text-dialog ${overlayClass}`"
        @cancel="handleClose"
    >
        <template #title>
            <div class="custom-dialog-header-bg"></div>
            <span class="custom-dialog-header-text">{{ data.title }}</span>
        </template>
        <div class="custom-dialog-content">
            <!--bca-disable-->
            <div
                class="message-content"
                v-html="data.content"
            ></div>
            <!--bca-enable-->
        </div>
        <template #foot>
            <veui-button
                v-show="showConfirm"
                theme="ai"
                ui="primary"
                class="ok-btn"
                :class="confirmClass"
                @click="handleOk"
            >{{ confirmText }}</veui-button>
            <veui-button
                v-show="showCancel"
                theme="ai"
                ui="warning"
                class="cancel-btn"
                @click="handleClose"
            >{{ cancelText }}</veui-button>
        </template>
    </veui-dialog>
</template>

<script>
import {Dialog, Button} from 'veui';
export default {
    inject: ['alsLog'],
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
        };
    },
    computed: {
        jsonContent() {
            return this.data.jsonContent || {};
        },
        confirmText() {
            return this.jsonContent.confirmText || '点击查看';
        },
        confirmRoute() {
            return this.jsonContent.confirmRoute || 'homeV2Default';
        },
        // 默认显示确定按钮
        showConfirm() {
            return this.jsonContent.showConfirm !== false;
        },
        confirmClass() {
            let confirmClass = this.jsonContent.confirmClass || '';
            if (!this.showCancel) {
                confirmClass += ' ai-button large ';
            }
            return confirmClass;
        },
        // 默认不显示取消按钮
        showCancel() {
            return this.jsonContent.showCancel || false;
        },
        cancelText() {
            return this.jsonContent.cancelText || '取消';
        },
        overlayClass() {
            let overlayClass = this.jsonContent.overlayClass || '';
            if (!this.showCancel) {
                overlayClass += ' foot-center';
            }
            return overlayClass;
        }
    },
    watch: {
        open(to, from) {
            if (to && !from) {
                this.alsLog({
                    f1: 'messageDialogShow',
                    f2: 'show',
                    f11: `消息弹窗显示_${this.data.title}`
                });
            }
        }
    },
    methods: {
        async handleClose(log = true) {
            if (log) {
                this.alsLog({
                    f1: 'messageDialogClose',
                    f2: 'click',
                    f11: `关闭消息弹窗_${this.data.title}`
                });
            }
            this.$emit('update:open', false);
        },
        handleOk() {
            this.alsLog({
                f1: 'messageDialogConfirm',
                f2: 'click',
                f11: `${this.data.title}_${this.confirmText}_${this.confirmRoute}`
            });
            this.handleClose(false);

            const userid = this.$store.state.app.hairuo?.userid;
            this.$router.push({
                name: this.confirmRoute,
                params: {
                    userid: userid
                }
            });
            // this.$router.push({
            //     name: 'messageCenter',
            //     query: {
            //         active: this.data.messageType === 1 ? 'system' : 'personal'
            //     }
            // });
        }
    },
    mounted() {
    }
};
</script>

<style lang="less" scoped>
.custom-dialog {
    &-header-bg {
        width: 480px;
        height: 265.5px;
        position: absolute;
        left: -24px;
        top: -27px;
        background-image: url("../../assets/messageDialogBg.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    &-header-text {
        z-index: 208;
        color: var(----G9, #282C33);
        font-size: 18px;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
    }
    /deep/ .veui-ai-dialog-content {
        width: 480px;
        border-radius: 16px;
        box-shadow:
            0px 4px 28px 1px rgba(0, 71, 194, 0.04),
            0px 5px 30px 1px rgba(0, 71, 194, 0.05),
            0px 6px 32px 2px rgba(0, 71, 194, 0.06);
        overflow: hidden;
        padding-bottom: 0;
    }
    /deep/ .veui-ai-dialog-content-head {
        padding-bottom: 14px;
        align-items: center;
        &-title {
            position: relative;
        }

        &-close {
            &::after {
                border: 0 none !important;
                box-shadow: none;
            }
        }
    }
    /deep/ .veui-ai-dialog-content-foot {
        display: flex;
        flex-direction: row-reverse;
        padding: 24px;
        gap: 12px;
    }
    &-content {
        color: var(----G9, #282C33);
    }
    .message-content {
        position: relative;
        color: var(----G9, #282C33);
        text-align: center;
        font-size: 14px;
        line-height: 26px; /* 185.714% */
        white-space: pre-wrap;
        /deep/ a {
            color: #3A5BFD;
            white-space: nowrap;
        }
        max-width: 100%;
        max-height: 100%;
        /deep/ div {
            background-repeat: no-repeat;
            max-width: 100%;
            max-height: 100%;
        }
        /deep/ img {
            max-width: 100%;
            max-height: 100%;
        }
    }

}
.ok-btn {
    &.ai-button {
        background: linear-gradient(269.12deg, #8C54FF 0.05%, #6366FF 28.68%, #4971FF 47.02%, #5699FF 99.95%);
        &.large {
            width: 220px;
            height: 42px;
            border-radius: 21px;
            font-size: 16px;
        }
    }
}
</style>
<style lang="less">
.message-rich-text-dialog {
    &.message-dialog-full-image {
        .veui-ai-dialog-content {
            width: 560px;
            border-radius: 20px;
            .veui-ai-dialog-content-body {
                padding: 0;
                margin-top: -64px;
                margin-bottom: -88px;
            }
            .veui-ai-dialog-content-head,
            .veui-ai-dialog-content-foot {
                z-index: 2;
            }
        }
    }
    &.no-header {
        .veui-ai-dialog-content-head {
            &-title {
                display: none;
            }
        }
    }
    &.foot-center {
        .veui-ai-dialog-content-foot {
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
